import { useTranslation } from 'react-i18next';
import useFetchCurrentStatus from './useFetchCurrentStatus';
import { InventoryAvailabilityStatus } from '../../../core/apis/inventoryApi';
export const noOperation = {
    openModal: false,
    modalMessage: '',
    redirectOnClose: false,
    updateStatusInUrl: {
        shouldUpdate: false,
        newStatus: undefined,
    },
};
// Interval of 15mins
const POLLING_INTERVAL_IN_MS = 15 * 60 * 1000;
export const isAvailable = (status) => status === InventoryAvailabilityStatus.inStock || status === InventoryAvailabilityStatus.onItsWay;
const useInventoryStatusChange = (selectedStatus, skip = false) => {
    const { t } = useTranslation();
    const { data: pollingStatus, isUninitialized, isFetching, } = useFetchCurrentStatus(!skip, true, POLLING_INTERVAL_IN_MS);
    if (isUninitialized || isFetching || skip || !isAvailable(selectedStatus)) {
        return noOperation;
    }
    if (isAvailable(pollingStatus)) {
        // status has changed
        return {
            openModal: selectedStatus !== pollingStatus,
            modalMessage: selectedStatus === InventoryAvailabilityStatus.inStock && pollingStatus === InventoryAvailabilityStatus.onItsWay
                ? t('Shared.Common.inStockToOnItsWayStatusText')
                : t('Shared.Common.unknownToUnavailableStatusText'),
            redirectOnClose: false,
            updateStatusInUrl: {
                shouldUpdate: selectedStatus !== pollingStatus,
                newStatus: pollingStatus,
            },
        };
    }
    // current status is unavailable
    return {
        openModal: true,
        modalMessage: t('Shared.Common.onItsWayToUnavailableStatusText'),
        redirectOnClose: true,
        updateStatusInUrl: {
            shouldUpdate: false,
            newStatus: undefined,
        },
    };
};
export default useInventoryStatusChange;
